<template lang="pug">
#userapprove
  .title 审批意见
  el-input(v-model="comment" maxlength="200" show-word-limit type="textarea")
  .operButton
    el-button(type="primary" size="small" @click="transfer") 转交
    el-button(type="success" size="small" @click="agree") 同意
    el-button(type="danger" size="small" @click="rejectNodeFlow") 驳回
  choosePeople(ref="choosePeople" :canSelectSystemRole="false" :canSelectspecRole="false" :canSelectprojectRole="false"  @userSelected="userSelected" )
</template>

<script>
import flowService from "@/CommonDP/service/flow-service";
import choosePeople from "../config/choosePeople.vue";
import { approveParams } from "../config";
export default {
  components: { choosePeople },
  props: {
    getBasicData: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      comment: ""
    };
  },
  computed: {
    nodeList() {
      return approveParams.nodeList;
    },
    flowNodeId() {
      // nodeStatus:0：拒绝 1：同意 2：审批中 3：发起 4：再发起 5：撤销
      return this.nodeList.find(e => e.nodeStatus === "2").flowNodeId;
    },
    // 下个节点的id 没有默认为0
    flowNextNodeId() {
      const index = this.nodeList.findIndex(e => e.nodeStatus === "2");
      return this.nodeList[index + 1]?.flowNodeDefinitionId || 0;
    },
    // 下个节点是否允许增加审批人
    allowAddApproverDynamic() {
      const index = this.nodeList.findIndex(e => e.nodeStatus === "2");
      return this.nodeList[index + 1]?.allowAddApproverDynamic || 0;
    },
    // 下个节点的人员信息
    nextNodeUserDtoList() {
      return approveParams.nodeAssigneeList.find(e => e.flowNodeDefinitionId === this.flowNextNodeId)?.userDtoList;
    },
    nextNodeAssignee() {
      return {
        flowNodeDefinitionId: this.flowNextNodeId,
        userDtoList: this.nextNodeUserDtoList
      };
    }

  },
  methods: {
    transfer() {
      this.$refs.choosePeople.openDialog();
    },
    async agree() {
      // 下个节点允许增加审批人
      if (this.allowAddApproverDynamic === 1) {
        if (this.nextNodeUserDtoList && this.nextNodeUserDtoList.length === 0) {
          this.$message.warning("请先选择下个节点的审批人");
          return;
        }
      }
      this.$confirm(`确认同意吗?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const json = await this.getBasicData();
        const params = {
          comment: this.comment,
          fileIds: [],
          flowInstanceNodeId: this.flowNodeId,
          json,
          nextNodeAssignee: this.allowAddApproverDynamic === 1 ? this.nextNodeAssignee : {}
        };
        await flowService.agree(params);
        this.$success("操作成功");
        this.$emit("closeDialog");
      }).catch((error) => {
        console.log(error);
      });
    },
    rejectNodeFlow() {
      if (!this.comment) {
        this.$message.error("驳回意见不能为空");
        return;
      }
      this.$confirm("此操作将流程驳回至发起人，发起人再次提交后方能继续。确认驳回吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const json = await this.getBasicData();
        const params = {
          comment: this.comment,
          fileIds: [],
          flowInstanceNodeId: this.flowNodeId,
          json,
          name: "",
          transferId: ""
        };
        await flowService.rejectNodeFlow(params);
        this.$success("操作成功");
        this.$emit("closeDialog");
      }).catch((error) => {
        console.log(error);
      });
    },
    async userSelected(val) {
      if (val.length === 0 || val.length > 1) {
        this.$message.info("请选择一人转交");
        return;
      } else {
        const transferId = val[0].userId;
        const params = {
          flowInstanceNodeId: this.flowNodeId,
          transferId
        };
        await flowService.transfer(params);
        this.$emit("closeDialog");
        this.$success("转交成功");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title{
  line-height: 40px;
  font-size: 14px;
}
.operButton{
  margin-top: 10px;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

}
</style>
